import React from "react";
import "./Stats.css";

const companies = [
  { name: "Forum Bank", url: "https://www.forum-bank.com" },
  { name: "GamePoint", url: "https://www.gamepoint.com" },
  { name: "Gide", url: "https://www.gide.com" },
  { name: "GK Software", url: "https://www.gk-software.com" },
  { name: "Global Bilgi", url: "https://www.global-bilgi.com" },
  { name: "SEB", url: "https://www.seb.se" },
  { name: "Sharda Cropchem", url: "https://www.shardacropchem.com" },
  { name: "Software AG", url: "https://www.softwareag.com" },
  { name: "Spartez", url: "https://www.spartez.com" },
  { name: "Symphony Solutions", url: "https://www.symphony-solutions.com" },
  { name: "SysIQ", url: "https://www.sysiq.com" },
  { name: "Teradata", url: "https://www.teradata.com" },
  { name: "UniFi", url: "https://www.ui.com" },
  { name: "Ubisoft", url: "https://www.ubisoft.com" },
  { name: "Playtika", url: "https://www.playtika.com/" },
];

const Stats: React.FC = () => {
  return (
    <section className="companies">
      <div className="companies__container">
        <p className="companies__label">Companies we've worked with</p>
        <div className="companies__marquee">
          <div className="companies__track">
            {companies.map((company, i) => (
              <a
                className="companies__item"
                key={i}
                href={company.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {company.name}
              </a>
            ))}
            {companies.map((company, i) => (
              <a
                className="companies__item"
                key={`dup-${i}`}
                href={company.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {company.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
